export const chatbotData = {
    intents: [
        {
            id: "account_login_help",
            keywords: {
                en: ["login", "otp", "password", "blocked", "cant login", "sign in"],
                ta: ["login", "otp", "password", "block", "ulnulaiya mudiyala"]
            }
        },
        {
            id: "profile_update",
            keywords: {
                en: ["update profile", "photo", "portfolio", "edit profile", "image"],
                ta: ["profile update", "photo", "portfolio", "padam"]
            }
        },
        {
            id: "subscription_payment",
            keywords: {
                en: ["payment", "deducted", "refund", "renew", "plan", "money"],
                ta: ["panam", "payment", "refund", "renew", "plan", "kaasu"]
            }
        },
        {
            id: "booking_issue",
            keywords: {
                en: ["booking", "pending", "cancel", "customer reply", "order"],
                ta: ["booking", "cancel", "customer", "order"]
            }
        },
        {
            id: "technical_issue",
            keywords: {
                en: ["crash", "slow", "bug", "not working", "error", "app"],
                ta: ["work aagala", "slow", "crash", "error", "app"]
            }
        },
        {
            id: "safety_complaint",
            keywords: {
                en: ["rude", "scam", "threat", "unsafe", "abuse", "danger"],
                ta: ["mariyadhai", "bayama", "thitturanga", "mosadi", "abathu"]
            }
        },
        {
            id: "pricing_help",
            keywords: {
                en: ["price", "cost", "charge", "rate", "how much"],
                ta: ["vilai", "evlo", "rate", "charge"]
            }
        },
        {
            id: "talk_to_support",
            keywords: {
                en: ["agent", "human", "support", "call", "person"],
                ta: ["agent", "pesanum", "support", "call", "aalu"]
            }
        }
    ],
    scripts: {
        start: {
            en: {
                text: "Hi! 👋 Welcome to NammaEventz Worker Support. How may I help you today?",
                options: ["Account / Login", "Profile", "Payment", "Booking", "Technical Help", "Pricing Help", "Safety / Complaint", "Talk to Support"]
            },
            ta: {
                text: "Vanakkam! 😊 NammaEventz Worker Support-ku varaveergal. Ungalukku enna help venum?",
                options: ["Account / Login", "Profile", "Payment", "Booking", "Technical Help", "Pricing Help", "Safety / Complaint", "Talk to Support"]
            }
        },
        fallback: {
            en: {
                text: "Sorry, I didn’t get that. Are you asking about Account, Payment, Profile, or Booking?",
                options: ["Account", "Payment", "Profile", "Booking"]
            },
            ta: {
                text: "Sorry, puriyala. Unga problema enna nu sollunga. Account, Payment, Profile illa Booking?",
                options: ["Account", "Payment", "Profile", "Booking"]
            }
        },
        account_login_help: {
            start: {
                en: {
                    text: "What seems to be the issue with your account?",
                    options: ["OTP Issue", "Forgot Password", "Account Blocked"]
                },
                ta: {
                    text: "Unga account-la enna prachana?",
                    options: ["OTP Varala", "Password Marandhuten", "Account Block Aagiruku"]
                }
            },
            otp_issue: {
                en: {
                    text: "Please check if your mobile number is correct and active. Try restarting your phone.",
                    options: ["Still not working", "Fixed"]
                },
                ta: {
                    text: "Unga mobile number correct-a irukkanu check pannunga. Phone-a restart panni paarunga.",
                    options: ["Innum work aagala", "Sari aayiduchu"]
                }
            },
            blocked: {
                en: {
                    text: "Your account might be paused due to expiry or admin action. Please provide your Registered Mobile Number.",
                    input: "phone"
                },
                ta: {
                    text: "Unga account expire aagirukkalam. Unga Registered Mobile Number-a anuppunga.",
                    input: "phone"
                }
            }
        },
        profile_update: {
            start: {
                en: {
                    text: "What do you want to update?",
                    options: ["Profile Photo", "Portfolio Images", "Personal Details"]
                },
                ta: {
                    text: "Edha update panna virumbureenga?",
                    options: ["Profile Photo", "Portfolio Images", "Personal Details"]
                }
            },
            guide: {
                en: {
                    text: "Go to **My Profile** > **Edit**. Upload high-quality images (under 5MB). Profile updates take 24-48 hours for approval.",
                    options: ["Upload Failed?", "Approval Status"]
                },
                ta: {
                    text: "**My Profile** > **Edit** ponga. Nalla quality photos (5MB kulla) upload pannunga. Approval aaga 24-48 hours aagum.",
                    options: ["Upload Aagala?", "Approval Status"]
                }
            }
        },
        subscription_payment: {
            start: {
                en: {
                    text: "Is this about a recent payment or renewal?",
                    options: ["Payment Deducted", "Renewal", "Plan Inactive"]
                },
                ta: {
                    text: "Idhu payment pathiya illa renewal pathiya?",
                    options: ["Payment Deducted", "Renewal", "Plan Inactive"]
                }
            },
            details: {
                en: {
                    text: "Please share the Payment ID (e.g., pay_123) or a screenshot.",
                    input: "text"
                },
                ta: {
                    text: "Payment ID (e.g., pay_123) illa screenshot anuppunga.",
                    input: "text"
                }
            }
        },
        booking_issue: {
            start: {
                en: {
                    text: "Please enter the Booking ID (e.g., BK-999).",
                    input: "text"
                },
                ta: {
                    text: "Booking ID (e.g., BK-999) sollunga.",
                    input: "text"
                }
            },
            options: {
                en: {
                    text: "What is the problem with this booking?",
                    options: ["Customer Not Replying", "Want to Cancel", "Payment Pending"]
                },
                ta: {
                    text: "Indha booking-la enna prachana?",
                    options: ["Customer Reply Pannala", "Cancel Pannanum", "Payment Varala"]
                }
            },
            advice: {
                en: {
                    text: "If customer is unresponsive for 24hrs, you can cancel without penalty.",
                    options: ["Create Ticket", "Go Back"]
                },
                ta: {
                    text: "Customer 24hrs-a reply pannalana, neenga cancel pannalam. Penalty irukkadhu.",
                    options: ["Ticket Podunga", "Thirumba Ponga"]
                }
            }
        },
        technical_issue: {
            start: {
                en: {
                    text: "Are you facing this issue on the App or Website?",
                    options: ["App", "Website"]
                },
                ta: {
                    text: "Idhu App-la varudha illa Website-la varudha?",
                    options: ["App", "Website"]
                }
            },
            fix: {
                en: {
                    text: "Please clear cache and update the app to the latest version.",
                    options: ["Still Facing Issue", "Fixed"]
                },
                ta: {
                    text: "Cache clear pannitu, app-a update panni paarunga.",
                    options: ["Innum work aagala", "Sari aayiduchu"]
                }
            }
        },
        pricing_help: {
            start: {
                en: {
                    text: "Pricing Formula: Cost + Travel + Time + Profit. Don't undersell yourself!",
                    options: ["See Price Ranges", "Negotiation Tips"]
                },
                ta: {
                    text: "Pricing Formula: Selavu + Travel + Neram + Laabam. Kammiya kekkadheenga!",
                    options: ["Price Ranges", "Negotiation Tips"]
                }
            },
            ranges: {
                en: {
                    text: "**Recommended Ranges:**\n• Photo: ₹15k-50k\n• DJ: ₹10k-30k\n• Makeup: ₹5k-20k",
                    options: ["Thanks"]
                },
                ta: {
                    text: "**Recommended Ranges:**\n• Photo: ₹15k-50k\n• DJ: ₹10k-30k\n• Makeup: ₹5k-20k",
                    options: ["Nandri"]
                }
            }
        },
        safety_complaint: {
            start: {
                en: {
                    text: "⚠️ **Are you safe right now?**",
                    options: ["YES", "NO - EMERGENCY"]
                },
                ta: {
                    text: "⚠️ **Neenga ippo safe-a irukkeengala?**",
                    options: ["Aama", "Illai - EMERGENCY"]
                }
            },
            emergency: {
                en: {
                    text: "Please move to a safe place and call 100 if needed. We are alerting the admin.",
                    options: ["Call Support"]
                },
                ta: {
                    text: "Udane safe-ana edathukku ponga. Thevaipatta 100-ku call pannunga. Admin-ku inform panrom.",
                    options: ["Call Support"]
                }
            },
            report: {
                en: {
                    text: "Please provide the Booking ID and details of the incident.",
                    input: "text"
                },
                ta: {
                    text: "Booking ID matrum nadandha vishayatha sollunga.",
                    input: "text"
                }
            }
        },
        talk_to_support: {
            start: {
                en: {
                    text: "I will connect you to a human agent. Please describe your issue briefly.",
                    input: "text"
                },
                ta: {
                    text: "Ungala human agent kitta connect panren. Unga prachanaya sollunga.",
                    input: "text"
                }
            }
        },
        ticket_created: {
            en: {
                text: "✅ Ticket Created! Our team will contact you shortly. Ticket ID: #TKT-",
                options: ["Main Menu"]
            },
            ta: {
                text: "✅ Ticket Create Aayiduchu! Enga team ungala seekiram contact pannuvanga. Ticket ID: #TKT-",
                options: ["Main Menu"]
            }
        }
    }
};
